const axillaLump= [

    { 
    label:"Number:",
    controlType:"radio button",
    options:["Single ", "Multiple"]
    },

    {
    label:"Max Size (cm)",
    controlType:"text",
    options:[]
    },

    { 
    label:"Side",
    controlType:"radio button",
    options:["Right", "Left", "Bilateral"]
    },

    { 
    label:"Area(s) of axilla",
    controlType:"checkbox group",
    options:["Superior", "Anterior", "Posterior", "Lateral", "Medial"]
    },
    
    { 
    label:"Consistency:",
    controlType:"radio button",
    options:["Hard", "Soft"]
    },

    { 
    label:"Shape:",
    controlType:"radio button",
    options:["Smooth", "Irregular"]
    },

    { 
    label:"Pain:",
    controlType:"radio button",
    options:["Painful", "Painless"]
    },

    { 
    label:"Tenderness:",
    controlType:"radio button",
    options:["Tender", "Non-tender"]
    },

    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
    
]


export default axillaLump